import { Layout, Page } from "@fdoh/health-ui-react";
import { useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";
import SetBacksInspectionForm from "../Components/SetBacksInspectionForm";
import { SetBacksInspectionInput } from "../Components/SetBacksInspectionForm.types";


// TODO: Add error handling


const CreateSetBacksPage = () => {
    const { search } = useLocation();
    const { state }: any = useLocation();
    const lastInspectionStatusData = state?.lastInspectionStatusData; 
  const searchParams = new URLSearchParams(search);
 const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
 const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');

    // Pre-populate the specified fields from lastInspectionStatusData
    const prePopulatedData = lastInspectionStatusData ? {
        ...lastInspectionStatusData,
        surfaceWater: lastInspectionStatusData.surfaceWaterDetails,
        ditches: lastInspectionStatusData.ditchesDetails,
        privateWells: lastInspectionStatusData.privateWellsDetails,
        publicWells: lastInspectionStatusData.publicWellsDetails,
        irrigationWells: lastInspectionStatusData.irrigationWellsDetails,
        portableWaterLines: lastInspectionStatusData.potableWaterLinesDetails,
        buildingFoundation: lastInspectionStatusData.buildingFoundationDetails,
        propertyLines: lastInspectionStatusData.propertyLinesDetails,
        otherComment: lastInspectionStatusData.description,
        otherSetback: lastInspectionStatusData.otherDetails
    } : null;

  return applicationId ? (
   
    <Page.Container>
       <ApplicationDetailsPage id={parseInt(applicationId)}></ApplicationDetailsPage>     
      <Page.Body>
        <Layout.Container>
          <SetBacksInspectionForm
                      id="createSetBacksInspectionForm"
                      title="Setbacks Inspection"
                      applicationId = {applicationId ? applicationId : 0 }
                      applicationInspectionId = {inspectionId? inspectionId: 0}
                      action="post"
                      returnPath={`/inspectionDetails/${inspectionId}`}
                      values={prePopulatedData}
            
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <div>
    
  </div>;
};

export default CreateSetBacksPage;